import { createContext, useState, useEffect } from "react";
const FeedbackContext = createContext();

export const FeedbackProvider = ({ children }) => {
  const [feedback, setFeedback] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [feedbackEdit, setFeedbackEdit] = useState({
    item: {},
    edit: false,
  })

  useEffect(() => {
    fetchFeedback();
  }, []);

  const fetchFeedback = async () => {
    const response = await fetch(`${process.env.REACT_APP_API}/feedback`);
    // const response = await fetch(`/feedback?_sort=id&_order=desc`);
    const data = await response.json();
    setFeedback(data);
    setIsLoading(false);
  }

  // add feedback
  const addFeedback = async (newFeedback) => {
    const response = await fetch(`${process.env.REACT_APP_API}/feedback`,{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(newFeedback)
    });
    const data = await response.json();
    setFeedback([data, ...feedback]);
  };

  // delete feedback
  const deleteFeedback = async (id) => {
    if (window.confirm("Are you sure you want to delete")) {
      await fetch(`${process.env.REACT_APP_API}/feedback/${id}`, {
        method: 'DELETE'
      });
      // menampilkan feedback yang tidak sama dengan id yang dikirim
      setFeedback(feedback.filter((item) => item.id !== id));
    }
  };

  // update feedback
  const updateFeedback = async (id, updateItem) => {
    const response = await fetch(`${process.env.REACT_APP_API}/feedback/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updateItem)
    })
    const data = await response.json();
    setFeedback(feedback.map((item) => item.id === id ? {...item, ...data} : item))
  }

  // set item to be updated
  const editFeedback = (item) => {
    setFeedbackEdit({
      item,
      edit: true
    });
  }

  return <FeedbackContext.Provider value={{
    feedback,
    deleteFeedback,
    addFeedback,
    editFeedback,
    feedbackEdit,
    updateFeedback,
    isLoading
  }}>{children}</FeedbackContext.Provider>;
};

export default FeedbackContext;
